import { useState } from "react";

export function useInput(defaultValue, validationFunction) {
  const [enteredValue, setEnteredValue] = useState(defaultValue);
  const [didEdit, setDidEdit] = useState(false);
  const [enteredId, setEnteredId] = useState(null);
  const [externalError, setExternalError] = useState("");

  function setErrorMessage(message) {
    setExternalError(message);
  }

  // Get the validation message directly
  const validationMessage = validationFunction(enteredValue);
  const hasError = didEdit && validationMessage !== "";

  function handleInputChange(event) {
    const { type, value, options, selectedIndex, id } = event.target;

    if (type === "select-one") {
      const selectedOptionId = options[selectedIndex].id;
      setEnteredValue(value);
      setEnteredId(selectedOptionId);
    } else {
      setEnteredValue(value);
      setEnteredId(id || null);
    }
    setExternalError("");
    setDidEdit(false);
  }

  function handleInputBlur() {
    setDidEdit(true);
  }

  function reset() {
    setEnteredValue(defaultValue);
    setDidEdit(false);
    setEnteredId(null);
    setExternalError("");
  }

  return {
    value: enteredValue,
    setValue: setEnteredValue,
    id: enteredId,
    setId: setEnteredId,
    handleInputChange,
    handleInputBlur,
    hasError,
    errorMessage: hasError ? validationMessage : externalError,
    setErrorMessage,
    reset,
  };
}
